import { Component } from "react";
import { Link } from "react-router-dom";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Unhandled render error", {
      message: error?.message,
      stack: error?.stack,
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-black flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <p className="text-4xl mb-6">⚠️</p>
          <h1 className="text-xl font-bold mb-2" style={{ color: "#E1E0CC" }}>
            Something went wrong
          </h1>
          <p className="text-gray-400 text-sm mb-8">
            An unexpected error occurred. Refreshing the page usually fixes this.
          </p>
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={() => window.location.reload()}
              className="px-5 py-2.5 rounded-full bg-primary text-black text-sm font-medium hover:bg-primary/90 transition-colors"
            >
              Refresh page
            </button>
            <Link
              to="/"
              onClick={() => this.setState({ hasError: false, error: null })}
              className="px-5 py-2.5 rounded-full bg-[#111] border border-white/10 text-gray-300 text-sm hover:bg-[#1a1a1a] transition-colors"
            >
              Go home
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
